import React, { Component } from 'react';
import ReactGA from 'react-ga';
import { Route } from 'react-router-dom';
class GoogleAnalytics extends Component {
  componentDidMount() {
    this.logPageChange(this.props.location.pathname, this.props.location.search);
  }
  componentDidUpdate(_ref) {
    let {
      location: prevLocation
    } = _ref;
    const {
      location: {
        pathname,
        search
      }
    } = this.props;
    const isDifferentPathname = pathname !== prevLocation.pathname;
    const isDifferentSearch = search !== prevLocation.search;
    if (isDifferentPathname || isDifferentSearch) {
      this.logPageChange(pathname, search);
    }
  }
  logPageChange(pathname) {
    let search = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    const page = pathname + search;
    const {
      location
    } = window;
    ReactGA.set({
      page,
      location: "".concat(location.origin).concat(page),
      ...this.props.options
    });
    ReactGA.pageview(page);
  }
  render() {
    return null;
  }
}
GoogleAnalytics.defaultProps = {
  options: {}
};
const RouteTracker = () => /*#__PURE__*/React.createElement(Route, {
  component: GoogleAnalytics
});
const init = function () {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    REACT_APP_GA_TRACKING_ID,
    REACT_APP_GA_DEBUG
  } = process.env;
  const isGAEnabled = !!REACT_APP_GA_TRACKING_ID;
  if (isGAEnabled) {
    ReactGA.initialize(REACT_APP_GA_TRACKING_ID, {
      debug: REACT_APP_GA_DEBUG === 'true',
      ...options
    });
  }
  return isGAEnabled;
};
export default {
  GoogleAnalytics,
  RouteTracker,
  init,
  ReactGA
};